import React, { useState } from "react";
import { Play, X } from "lucide-react";
import { FILMS } from "../mock";
import { useEnquiry } from "../context/EnquiryContext";

const Films = () => {
  const [active, setActive] = useState(null);
  const { open: openEnquiry } = useEnquiry();

  return (
    <section id="films" className="py-24 md:py-32 bg-[#f5efe6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 reveal">
          <div className="max-w-2xl">
            <p className="kicker mb-5">Our Work</p>
            <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
              Real weddings.<br/>
              <span className="italic font-light">Real love. Real tears.</span>
            </h2>
          </div>
          <p className="font-serif italic text-[#6b6259] text-lg max-w-sm md:text-right">
            Every film is different. Because every couple is.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {FILMS.map((f, i) => (
            <button
              key={f.id}
              onClick={() => setActive(f)}
              className={`film-tile text-left aspect-[4/5] reveal ${i === 1 ? "md:translate-y-10" : ""} ${i === 4 ? "md:translate-y-10" : ""}`}
              type="button"
            >
              <img
                src={`https://img.youtube.com/vi/${f.id}/maxresdefault.jpg`}
                alt={`${f.couple} at ${f.venue}`}
                className="w-full h-full object-cover"
                onError={(e) => { e.currentTarget.src = `https://img.youtube.com/vi/${f.id}/hqdefault.jpg`; }}
              />
              <div className="film-play">
                <div className="ring">
                  <Play size={22} className="text-[#f5efe6] ml-1" fill="#f5efe6" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-[#f5efe6]">
                <p className="text-[0.68rem] tracking-[0.3em] uppercase text-[#c9a87c] mb-2">Wedding Film</p>
                <h3 className="font-display text-3xl leading-tight display-tight">{f.couple}</h3>
                <p className="text-sm font-light text-[#e8dfc9]/90 mt-1">{f.venue}</p>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-20 text-center reveal">
          <p className="font-serif italic text-2xl md:text-3xl text-[#1f1d1a] mb-2">
            Want something like this for your wedding?
          </p>
          <p className="text-[#6b6259] font-light mb-8">Drop us your details and we'll have a chat.</p>
          <button onClick={openEnquiry} className="btn-primary">Secure Your Date</button>
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 md:p-10" onClick={() => setActive(null)}>
          <button className="absolute top-6 right-6 text-[#f5efe6] p-2" aria-label="Close" onClick={() => setActive(null)}>
            <X size={28} />
          </button>
          <div className="w-full max-w-5xl aspect-video relative" onClick={(e) => e.stopPropagation()}>
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${active.id}?autoplay=1&rel=0`}
              title={`${active.couple} wedding film`}
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
            <div className="absolute -bottom-12 left-0 right-0 text-center text-[#f5efe6]">
              <p className="font-display text-2xl">{active.couple}</p>
              <p className="text-sm text-[#c9a87c]">{active.venue}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Films;
